import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { Module } from '../entities/module';

/**
 * Base url
 */
const BASE_URL = 'users/rights/list/modules';

/**
 * Module serivce
 */
@Injectable({
  providedIn: 'root',
})
export class ModuleService {
  /**
   * Constructor
   *
   * @param apiService ApiService
   */
  constructor(private apiService: ApiService) {}

  /**
   * List
   *
   * @returns Observable with modules
   */
  list(): Observable<Module[]> {
    return this.apiService.get(BASE_URL).pipe(map((modules) => modules.map((module: any) => Module.createFromJson(module))));
  }
}
